import { domReady } from '../modules/utils.js';

class StickyCards extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = {
      top: this.querySelector('.stickycards-top'),
    };
    this.#setListeners();
    this.#updateOffset();
  }

  disconnectedCallback() {
    this.#unsetListeners();
  }

  #setListeners() {
    if (!this.refs.top) return;
    this.resizeObserver = new ResizeObserver(this.#updateOffset);
    this.resizeObserver.observe(this.refs.top);
  }

  #unsetListeners() {
    this.resizeObserver?.disconnect();
  }

  #updateOffset = () => {
    this.style.setProperty('--stickycards-offset', `${this.refs.top.offsetHeight}px`);
  };
}

customElements.define('sticky-cards', StickyCards);
